<div class="splash loading" *ngIf="isLoading">
  <p>{{ getRessource('Loading') }}</p>
</div>

<ng-container *ngIf="!isLoading && emlData">
  <app-eml-viewer [emlRaw]="emlData">
  </app-eml-viewer>
</ng-container>
